import { render, staticRenderFns } from "./CRD.vue?vue&type=template&id=e698e570&"
import script from "./CRD.vue?vue&type=script&lang=js&"
export * from "./CRD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports